export const getStatus = (insuranceStatus) =>
  Object.keys(insuranceStatus).find((key) => insuranceStatus[key] === true)

export const decapitalizeFirstLetter = (string) => string.charAt(0).toLowerCase() + string.slice(1)

export const insertAnd = (string) => {
  const parts = string.split(", ")
  if (parts.length > 1) {
    const last = parts.pop()
    return `${parts.join(", ")} and ${last}`
  }
  return string
}

// Required fields must have at least two letters or numbers, so "-" or a single
// character is rejected. \p{L}\p{N} (with /u) counts letters from any alphabet,
// not just English.
const REQUIRED_TEXT_FIELDS = {
  insurer: "Insurer",
  brokerName: "Broker Name",
  policyNumber: "Policy Number",
  jurisdiction: "Jurisdiction",
}

export const validateCertificate = (values) => {
  const errors = {}

  Object.entries(REQUIRED_TEXT_FIELDS).forEach(([field, label]) => {
    const value = values[field]
    if (typeof value !== "string" || (value.match(/[\p{L}\p{N}]/gu) || []).length < 2) {
      errors[field] = `Enter a valid ${label}.`
    }
  })

  return errors
}

export const getMinimumCoverageRequirement = (selectedCategories, categories) => {
  let maxMinimumCoverage = 0
  categories.forEach((category) => {
    if (
      selectedCategories.includes(category.categoryId) &&
      category.minimumCoverage > maxMinimumCoverage
    ) {
      maxMinimumCoverage = category.minimumCoverage
    }
  })

  return maxMinimumCoverage
}
